// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-projects_foreign-admits_src_app_loan-gtm_loan-gtm-routing_module_ts":"722999609011f8f5","projects_foreign-admits_src_app_loan-gtm_loan-gtm_module_ts":"31602d8f464ecb79","projects_apna-lib_src_lib_components_page404_page404_module_ts":"d41cc05fca493155"}[chunkId] + ".js";
};